import moment from "moment";
import { chartColors } from "views/applications-id-report/slices/IncomeReportSlice/components/constants";
import { VerifiedIncomeGraphData } from "../types";
import { ApplicantType, VerificationNames } from "shared/types";
import { VerifiedIncomeReport } from "types/landlord/reports";
import { Applicant } from "types/application";
import { getFullName } from "shared/utils/get-full-name";
import { getApplicantRole } from "utils/getApplicantRole";

export const generateQueries = (applicants?: Applicant[]) => {
  return applicants?.flatMap((applicant) => {
    const verifiedIncomeVerification = applicant.verifications.find(
      (v) => v.name === VerificationNames.VerifiedIncomeVerification
    );

    const ret = verifiedIncomeVerification?.id
      ? [
          {
            applicant: getFullName({
              firstName: applicant.first_name,
              lastName: applicant.last_name,
              middleName: applicant.middle_name,
              short: true
            }),
            role: applicant.role,
            verification: verifiedIncomeVerification
          }
        ]
      : [];

    return ret;
  });
};

// TODO: rewrite this ENTIRE function when release comes
export const getIncomeGraphsData = (verifiedIncomeData) => {
  let colorIndex = 0;
  let totalPastThreeMonthsAvg: number | undefined = undefined;
  let totalVerifiedNet: number | undefined = undefined;

  const verifiedIncomeGraphData = verifiedIncomeData?.flatMap(
    (
      verifiedItem: {
        verification: {
          summary: VerifiedIncomeReport;
        };
      } & {
        applicant: string;
        role: ApplicantType;
      }
    ) => {
      const color = chartColors[colorIndex % chartColors.length];
      colorIndex++;

      const role = getApplicantRole(verifiedItem.role);

      const verifiedNetIncomeCents =
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        verifiedItem.verification?.summary?.net_monthly_income?.cents;
      if (verifiedNetIncomeCents)
        totalVerifiedNet =
          totalVerifiedNet === undefined
            ? verifiedNetIncomeCents
            : totalVerifiedNet + verifiedNetIncomeCents;

      const combinedData: VerifiedIncomeGraphData[] = [];

      if (
        verifiedItem.verification.summary.net_income_summary &&
        verifiedItem.verification.summary.net_income_summary.length
      )
        combinedData.push({
          id: verifiedItem.applicant,
          role: role,
          color: color,
          data: verifiedItem.verification.summary.net_income_summary.map(
            (item) => ({
              x: moment(item.month).format("MMM YY"),
              y: item.total_net ? item.total_net.cents / 100 : 0
            })
          )
        });

      // verifiedItem.verification?.report?.past_three_months_avg_total || --< was like this before. Saved for future reference
      const pastThreeMonthsAvg =
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, sonarjs/different-types-comparison
        verifiedItem.verification?.summary?.gross_monthly_income?.cents ==
        undefined
          ? undefined
          : verifiedItem.verification.summary.gross_monthly_income.cents / 100;

      if (pastThreeMonthsAvg)
        totalPastThreeMonthsAvg =
          totalPastThreeMonthsAvg === undefined
            ? pastThreeMonthsAvg
            : (totalPastThreeMonthsAvg += pastThreeMonthsAvg);

      return combinedData;
    }
  );

  return {
    verifiedIncomeGraphData
  };
};
